/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import splashAnimation from "./assets/lottie/developerYoga"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shubham Kale",
  title: "Hi there, I'm Shubham",
  subTitle:
    "Passionate Full Stack Software Developer 🚀 having an experience of building end-to-end Web applications and APIs from scratch with Java / ReactJS / NodeJS and some other cool libraries and frameworks.",
  resumeLink:
    "https://drive.google.com/file/d/1g9mT4TYYf4OwOBbgn-o7aObnaLPl___o/view", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/shubhamk54",
  linkedin: "https://www.linkedin.com/in/shubhamkale54/",
  gmail: "shubhamkale54@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

function getYears() {

  // Define the start date (June 2016)
  const startDate = new Date('2016-06-01');

  // Get the current date
  const currentDate = new Date();

  // Calculate the difference in years and months
  let yearsDiff = currentDate.getFullYear() - startDate.getFullYear();
  let monthsDiff = currentDate.getMonth() - startDate.getMonth();

  // Adjust for cases where the current month is earlier than the start month
  if (monthsDiff < 0) {
    yearsDiff--;
    monthsDiff += 12;
  }

  console.log(`Years: ${yearsDiff}, Months: ${monthsDiff}`);

  return `${yearsDiff}.${monthsDiff}`
}

const years = getYears();

const skillsSection = {
  title: "Next-Gen tech with",
  subTitle: "High Performance + Best practices + SOLID + Resiliency",
  skills: [
    "💼 " + years + " years of experience working in the Financial and Healthcare domains.",
    "⚡ Skilled in RESTful Web Services API development, creating responsive web apps using Front-end technologies.",
    "🤝 Full-stack developer with hands-on experience of setting up application infrastructure using cloud components and automated deployment process (CI/CD)",
    "👏 Consistently appreciated and rewarded by management and clients for initiatives, flexibility, optimal solutions and leadership.",
    "💻 End-to-end product developer with demonstrate history of working in various areas like requirement gathering from BA and clients, providing resilient designs followed by development with coding standards."
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring Boot",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Shell Scripting",
      fontAwesomeClassname: "fas fa-terminal"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
    {
      skillName: "Google Cloud",
      fontAwesomeClassname: "fas fa-cloud"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-dharmachakra"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "REST API",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Maven",
      fontAwesomeClassname: "fas fa-feather-alt"
    },
    {
      skillName: "Micro Services",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "KDK College of Engineering, Nagpur",
      logo: require("./assets/images/kdkLogo.png"),
      subHeader: "Bachelor’s in Computer Technology",
      duration: "Aug 2012 - May 2016",
      desc: "CGPA: 7.78",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Engineer",
      company: "HiLabs",
      companylogo: require("./assets/images/hilabs.jpeg"),
      date: "Aug 2022 – Present",
      desc: "",
      descBullets: [
        "Designed and developed the scheduling framework",
        "Managed the release and oversees the technical work",
        "Designed and reviewed HLDs, and LLDs to build generic modules",
        "Debugging and troubleshooting the application for critical issues.",
        "Created reusable components with ReactJS.",
        "Investigate and constantly improve scalability, performance, and reliability of the platform"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Credit Suisse",
      companylogo: require("./assets/images/cs.png"),
      date: "Dec 2020 – Aug 2022",
      desc: "",
      descBullets: [
        "Product design, re-architect, implementation with performance, stability, and availability.",
        "Code reviews, Sprint/Release Planning, effective design improvements, code optimization",
        "Micro front-ends with React, Angular 12, and TypeScript",
        "Migrated on-premise infrastructure to Cloud with Docker, Nginx, and OpenShift.",
        "Empowered application capabilities implementing Sonar-Qube, Code coverage setup, Swagger-API documentations, Cucumber Gherkins Test suite.",
        "Setted-up CI/CD pipelines and Infrastructure using Jenkins, Jfrog Artifactory, Docker, and Kubernetes on a private cloud"
      ]
    },
    {
      role: "Software Programmer",
      company: "Bitwise",
      companylogo: require("./assets/images/bitwise.png"),
      date: "Jun 2016 – Dec 2020",
      desc: "",
      descBullets: [
        "Capture end-to-end requirements as user stories in a Scrum/Agile environment.",
        "Real-Time System Interface (RTSI) and batch processing ",
        "Troubleshoot the production issues in due SLAs. Participating in MVP and product sprint demos",
        "POCs and POAs for cutting-edge features before they were integrated into the product",
        "Delivery with cloud using GCP components like Pub/Sub, Task queues, AppEngine, BigQuery, Compute Engine, Cloud Storage, Network services, etc",
        "Automated general processes for Health checks, alerts, weekly/monthly reports"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Few projects available",
  projects: [
    {
      image: require("./assets/images/kdkLogo.png"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/kdkLogo.png"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Achievements 🏆",
  subtitle: "",

  achievementsCards: [
    {
      title: "Special Recognition",
      subtitle:
        "Outstanding dedication and extraordinary efforts demonstrated while working on Clinical project.",
      image: require("./assets/images/special_recognition.png"),
      imageAlt: "Special Recognition Award",
      footerLink: [
        {
          name: "View Award",
          url: "https://drive.google.com/file/d/1Y0jsa74kJpDO071BdbEavyeNzjNDLVGX/view"
        }
      ]
    },
    {
      title: "Gold Star Award",
      subtitle:
        "Presented in Hilabs for outstanding performance",
      image: require("./assets/images/hilabs_gold_star.png"),
      imageAlt: "Gold Star Award",
      footerLink: [
        {
          name: "View Award",
          url: "https://drive.google.com/file/d/1g8R2ozWp6x87cBWUSkUjw_Q18UVPMRCX/view"
        }
      ]
    },
    {
      title: "Extra Miler Award",
      subtitle:
        "Presented in Hilabs for demonstrating core values like Responsibility, Commitment and Building trust",
      image: require("./assets/images/hilabs.jpeg"),
      imageAlt: "Extra Miler Award",
      footerLink: [
        {
          name: "View Award",
          url: "https://drive.google.com/file/d/1ef-pz1cxpxtTx4muJuaxjodUne3RD-4Q/view?usp=sharing"
        }
      ]
    },
    {
      title: "TIP Award: Innovations",
      subtitle:
        "Given by Credit Suisse for presenting innovative solutions in the Market Risk domain",
      image: require("./assets/images/cs.png"),
      imageAlt: "",
      footerLink: []
    },
    {
      title: "COP: Inner Source Hackathon",
      subtitle: "Participated as team and got special mention in Credit Suisse",
      image: require("./assets/images/cs.png"),
      imageAlt: "",
      footerLink: []
    },
    {
      title: "V Award: Outstanding Team performance in Q2 & Q3",
      subtitle: "Presented in Bitwise",
      image: require("./assets/images/v_award.jpeg"),
      imageAlt: "",
      footerLink: [
        {
          name: "View Award",
          url: "https://www.linkedin.com/posts/shubhamkale54_activity-6728494974972829696-FEHJ/"
        }
      ]
    },
    {
      title: "Excellence Award: Innovation & Creativity",
      subtitle: "Presented in Bitwise",
      image: require("./assets/images/excellence_1.jpeg"),
      imageAlt: "",
      footerLink: [
        {
          name: "View Award",
          url: "https://www.linkedin.com/posts/shubhamkale54_activity-6728495108959870976-_AEi/"
        }
      ]
    },
    {
      title: "Excellence Award: Excellence with passion",
      subtitle: "Presented in Bitwise",
      image: require("./assets/images/excellence_2.jpeg"),
      imageAlt: "",
      footerLink: [
        {
          name: "View Award",
          url: "https://www.linkedin.com/posts/shubhamkale54_excellenceaward-activity-6604828069859549184-fGWK/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: "Podcast 🎙️",
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [""],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Contact Me ☎️",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7276752633",
  email_address: "shubhamkale54@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
